import { API_URL } from "env";
import { AllPostsAPIResponse, CategoryTreeAPIResponse, Post } from './type';

const API_USE = API_URL

async function getAllPosts(page = 1, per_page = 10): Promise<AllPostsAPIResponse> {
    try {
        const res = await fetch(`${API_USE}/api/v1/be/posts?page=${page}&per_page=${per_page}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });
        const data = await res.json();
        return data;
    } catch (error) {
        console.error("Error fetching posts:", error);
        throw error;
    }
}

async function getPostById(id: number): Promise<Post> {
    try {
        const res = await fetch(`${API_USE}/api/v1/be/posts/${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });
        const data = await res.json();
        return data;
    } catch (error) {
        console.error(`Error fetching post with id ${id}:`, error);
        throw error;
    }
}

async function getAllCategories() {
    try {
        const res = await fetch(`${API_USE}/api/v1/be/categories`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });
        const data = await res.json();
        return data;
    } catch (error) {
        console.error("Error fetching categories:", error);
        throw error;
    }
}

async function getCategoryTree() : Promise<CategoryTreeAPIResponse[]> {
    try {
        const res = await fetch(`${API_USE}/api/v1/be/categories/tree`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });
        const data = await res.json();
        return data;
    } catch (error) {
        console.error("Error fetching category tree:", error);
        throw error;
    }
}

async function searchPosts(keyword: string, page = 1, per_page = 10): Promise<Post[]> {
    try {
        const res = await fetch(`${API_USE}/api/v1/be/posts/search?keyword=${encodeURIComponent(keyword)}&page=${page}&per_page=${per_page}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });
        const data = await res.json();

        if (Array.isArray(data)) {
            return data;
        }

        if (Array.isArray(data?.data)) {
            return data.data;
        }

        return [];
    } catch (error) {
        console.error(`Error searching posts with keyword "${keyword}":`, error);
        throw error;
    }
}

export { getAllPosts, getPostById, getCategoryTree, searchPosts };
